// QR Kiosk v2 — KV2-3 urgency segments (PG-14). Three giant deselectable segments
// (Low / High / Urgent) in designer order [4 Low, 2 High, 1 Urgent]. Tapping the
// active segment DESELECTS (urgency → undefined; the server field is nullable and
// "None" must stay reachable). No None segment, no value-3 segment (D9). Tokens only.
import React from "react";
import useTranslation from "../../../shared/hooks/useTranslation";
import { URGENCY_META } from "./reportUtils";
import { StatusPip } from "../shared/StatusPip";

// Designer order, left → right.
const SEGMENT_ORDER = [4, 2, 1];

export interface UrgencySegmentsProps {
  value?: number;
  onChange: (v: number | undefined) => void;
}

export function UrgencySegments({ value, onChange }: UrgencySegmentsProps) {
  const { translate } = useTranslation("public");
  return (
    <div
      style={{
        display: "flex",
        height: 48,
        borderRadius: 11,
        border: "1px solid var(--border)",
        background: "var(--card)",
        overflow: "hidden",
      }}
    >
      {SEGMENT_ORDER.map((code, i) => {
        const meta = URGENCY_META[code];
        const active = value === code;
        const tone = meta.tone;
        return (
          <button
            key={code}
            type="button"
            aria-pressed={active}
            onClick={() => onChange(active ? undefined : code)}
            style={{
              flex: 1,
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 7,
              fontSize: 14.5,
              border: "none",
              cursor: "pointer",
              fontFamily: "inherit",
              borderLeft: i > 0 ? "1px solid var(--border-soft)" : "none",
              fontWeight: active ? 700 : 500,
              color: active ? `color-mix(in oklab, var(${tone}) 80%, var(--ink))` : "var(--muted)",
              background: active ? `color-mix(in oklab, var(${tone}) 12%, var(--card))` : "transparent",
            }}
          >
            <StatusPip tone={tone} size={8} />
            {translate(meta.labelKey)}
          </button>
        );
      })}
    </div>
  );
}

export default UrgencySegments;
